import { useTranslation } from 'react-i18next';

import { usePathTo } from '@/utils/useUrlParams';
import { Button } from '@arco-design/web-react';
import { useHomepath } from '../403/';
import { ErrorPage } from '../errorPage';

export function Page404() {
  const { t } = useTranslation();
  const navigate = usePathTo();
  const backHome = useHomepath();

  return (
    <ErrorPage
      title="404"
      des={t('components:page.not.found.or.request.path.does.not.exist')}
      img="/images/img_404.png"
    >
      <>
        <Button onClick={() => navigate(-1)} type="primary">
          {t('common:back.to.previous.page')}
        </Button>
        <Button onClick={backHome} type="primary">
          {t('common:back.to.homepage')}
        </Button>
      </>
    </ErrorPage>
  );
}
